module.exports = __webpack_public_path__ + "img/reco2.9dc073c1.jpg";